import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class CustomReuseStrategy implements RouteReuseStrategy {
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return null;
    }
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.data.refreshComponent ? false : future.routeConfig === curr.routeConfig;
    }
    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    }
}